var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.042a6.724 6.724 0 00-6.593 5.405l-1.045 5.224a3.667 3.667 0 002.111 4.056 13.43 13.43 0 001.745.635l.086.195a4.044 4.044 0 007.392 0l.086-.195c.594-.17 1.177-.382 1.745-.634a3.667 3.667 0 002.111-4.057l-1.045-5.224A6.724 6.724 0 0010 1.042zm3.241 14.173a.628.628 0 00-.131.035 12.504 12.504 0 01-6.22 0 .626.626 0 00-.131-.035c-.606-.163-1.2-.373-1.778-.63a2.417 2.417 0 01-1.394-2.669l1.045-5.224a5.474 5.474 0 0110.736 0l1.045 5.224a2.417 2.417 0 01-1.394 2.67c-.577.256-1.172.466-1.778.63zm-5.367 1.513c1.407.22 2.845.22 4.252 0a2.795 2.795 0 01-4.252 0z"
  })));
}
export default SvgNotification;